import { MsalProvider } from '@azure/msal-react'

import { ReactNode, useEffect, useState } from 'react'

import { escucharLogoutDeOtrasPestanas } from './logout'
import { getMsalInstance, initializeMsal } from './msal'

import { EPublicRoutes } from '@/common/constants/routes/public.routes'

interface IMsalCustomProviderProps {
  children: ReactNode
}

const MsalCustomProvider: React.FC<IMsalCustomProviderProps> = ({
  children,
}) => {
  // MsalCustomProvider se monta DENTRO de ConfigRuntimeProvider, que bloquea el render
  // hasta hidratar /api/config. Por eso acá CLIENT_ID/API_SCOPE ya están disponibles y
  // getMsalInstance() crea la instancia real con la config correcta del ambiente.
  const [instance] = useState(() => getMsalInstance())

  useEffect(() => {
    initializeMsal()
  }, [])

  // Logout en OTRA pestaña: acá solo se purga el cache y se sale de la ruta privada. La sesión de
  // Entra ya la cerró la pestaña que inició el logout.
  //
  // El aviso de la propia pestaña no llega hasta acá: lo filtra `escucharLogoutDeOtrasPestanas`,
  // porque BroadcastChannel reparte a los demás canales del MISMO contexto y este handler
  // competía con el logoutRedirect en vuelo.
  //
  // Ojo con el cache: `authConfig` usa `cacheLocation: 'localStorage'`, así que es COMPARTIDO
  // entre pestañas, no uno por pestaña. Este `clearCache()` toca el de todas.
  useEffect(
    () =>
      escucharLogoutDeOtrasPestanas(() => {
        instance.clearCache().finally(() => window.location.assign(EPublicRoutes.AUTENTICACION))
      }),
    [instance],
  )

  return <MsalProvider instance={instance}>{children}</MsalProvider>
}

export default MsalCustomProvider
